require('./styles/index.scss')
import 'intersection-observer'
import 'regenerator-runtime/runtime.js'
import { hot } from 'react-hot-loader/root'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/wrapper'

const render = (Component) =>
  ReactDOM.render(<Component />, document.getElementById('root'))

render(hot(App))